import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";

// Dog profile sayfası için tüm async veri yüklemelerini barındıran custom hook.
// Component scope'da setState-içeren-async-fonksiyon antipattern'inden kaçınmak için
// gerekli, ama bonus olarak data fetching mantığını da reusable kılar.
export function useDogProfileData(dogId) {
  const [dog, setDog] = useState(null);
  const [healthRecords, setHealthRecords] = useState([]);
  const [events, setEvents] = useState([]);
  const [guardian, setGuardian] = useState(null);
  const [guardians, setGuardians] = useState([]);
  const [guardianCount, setGuardianCount] = useState(0);
  const [photos, setPhotos] = useState([]);
  const [videos, setVideos] = useState([]);
  const [comments, setComments] = useState([]);
  const [healthConfirmations, setHealthConfirmations] = useState(0);
  const [dogUpdates, setDogUpdates] = useState([]);
  const [dogUpdatesTotal, setDogUpdatesTotal] = useState(0);
  const [upcomingEvent, setUpcomingEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshTick, setRefreshTick] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const loadAll = async () => {
      const [dogRes, photoRes, vidRes, commentsRes, updatesRes, eventRes] = await Promise.all([
        axios.get(`${API}/dogs/${dogId}`).catch(() => null),
        axios.get(`${API}/dogs/${dogId}/photos`).catch(() => null),
        axios.get(`${API}/dogs/${dogId}/videos`).catch(() => null),
        axios.get(`${API}/dogs/${dogId}/comments`).catch(() => null),
        axios.get(`${API}/dogs/${dogId}/updates?limit=3`).catch(() => null),
        axios.get(`${API}/dogs/${dogId}/next-event`).catch(() => null),
      ]);
      if (cancelled) return;
      if (dogRes) {
        setDog(dogRes.data.dog);
        setHealthRecords(dogRes.data.health_records || []);
        setEvents(dogRes.data.events || []);
        setGuardian(dogRes.data.guardian);
        setGuardians(dogRes.data.guardians || []);
        setGuardianCount(dogRes.data.guardian_count || 0);
      }
      if (photoRes) setPhotos(photoRes.data.photos || []);
      if (vidRes) setVideos(vidRes.data.videos || []);
      if (commentsRes) {
        setComments(commentsRes.data.comments || []);
        setHealthConfirmations(commentsRes.data.health_confirmations || 0);
      }
      if (updatesRes) {
        setDogUpdates(updatesRes.data.updates || []);
        setDogUpdatesTotal(updatesRes.data.total || 0);
      }
      if (eventRes) setUpcomingEvent(eventRes.data.event || null);
      setLoading(false);
    };
    loadAll();
    return () => { cancelled = true; };
  }, [dogId, refreshTick]);

  // Bireysel refresh fonksiyonları (örn. fotoğraf yüklendikten sonra yeniden çek)
  const refreshAll = () => setRefreshTick((n) => n + 1);
  const refreshPhotos = async () => {
    const r = await axios.get(`${API}/dogs/${dogId}/photos`).catch(() => null);
    if (r) setPhotos(r.data.photos || []);
  };
  const refreshComments = async () => {
    const r = await axios.get(`${API}/dogs/${dogId}/comments`).catch(() => null);
    if (r) {
      setComments(r.data.comments || []);
      setHealthConfirmations(r.data.health_confirmations || 0);
    }
  };

  return {
    dog, healthRecords, events,
    guardian, guardians, guardianCount,
    photos, videos,
    comments, healthConfirmations,
    dogUpdates, dogUpdatesTotal,
    upcomingEvent,
    loading,
    refreshAll, refreshPhotos, refreshComments,
  };
}
